import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const observerError = /ResizeObserver loop completed with undelivered notifications/;
const origConsoleError = console.error;

console.error = function (msg, ...args) {
  if (typeof msg === 'string' && observerError.test(msg)) return;
  origConsoleError.apply(console, [msg, ...args]);
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
